"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_NEW_SITEMAP = void 0;
exports.GET_NEW_SITEMAP = `
  {
    getNewSitemap
  }
`;
//# sourceMappingURL=new-sitemap.js.map